<template>
  <Progressbar v-if="loading && !cities.length" />
  <NetworkError v-else-if="errors" @tryAgain="Auth.getCities()" />
  <div class="w-full h-64 md:h-96" :style="{ background: 'url(' + background + ') no-repeat', backgroundSize: 'cover' }" v-else>
  </div>
  <div class="card scrollbar-small block bg-white shadow-lg max-w-[560px] mx-auto w-full justify-center -mt-10 md:-mt-56" v-if="cities.length"
    :class="{ 'pointer-events-none': loading }">
    <div class="card-body pb-3 pt-2 px-4" :class="{ 'opacity-70': loading }">
      <Form @submit="onSubmit" class="p-4 h-full flex flex-col" v-slot="{ errors }">
        <div class="flex-1">
          <div class="flex justify-between">
            <small class="text-error">{{ __('Be sure to set the keyboard mode for numbers to English') }}</small>
            <button type="button" class="flex justify-end" @click="backButton">{{ __('Back') }}
            <ArrowLongLeftIcon class="h-6 w-6 inline-block" />
          </button>
          </div>
          <div class="form-control mt-3">
            <p v-if="enterCode">{{__('Verification code for mobile number') + ' ' + user.phone + ' ' + __('submited')}}</p>
              <Field type="text" :placeholder="`${__('First name')}`" name="first_name" v-model="user.first_name" v-if="!isAuth"
                rules="required" :class="{ 'input-error': errors.first_name }" v-show="!enterCode"
                class="input text-center text-blue-custom-2 bg-blue-custom-1 placeholder-blue-custom-2" />

              <Field type="text" :placeholder="`${__('Last name')}`" name="last_name" v-model="user.last_name" v-if="!isAuth"
                rules="required" :class="{ 'input-error': errors.last_name }" v-show="!enterCode"
                class="input mt-4 text-center text-blue-custom-2 bg-blue-custom-1 placeholder-blue-custom-2" />

            <Field type="tel" :placeholder="`${__('phone number')}`" name="phone" v-model="user.phone" inputmode="numeric"
              rules="required|digits:11" :class="{ 'input-error': errors.phone }" v-show="!enterCode"
              class="input mt-4 text-center text-blue-custom-2 bg-blue-custom-1 placeholder-blue-custom-2" />

            <Field type="tel" :placeholder="`${__('National Code')}`" name="national_code" v-model="user.national_code" inputmode="numeric"
              v-show="!enterCode" rules="required|digits:10" :class="{ 'input-error': errors.national_code }"
              class="input mt-4 text-center text-blue-custom-2 bg-blue-custom-1 placeholder-blue-custom-2" />

              <DatePicker v-show="!enterCode" initial-value="1360/06/15" v-model="user.birthday" :class="{ '!input-error': errors.birthday }" simple inputClass="input mt-4 text-center text-blue-custom-2 placeholder-blue-custom-2" :placeholder="__('Birthday')" name="birthday" />

              <Field type="number" :placeholder="`${__('Postal Code')}`" name="postal_code"
              v-model="user.postal_code" rules="required|digits:10"
              class="input mt-4 text-center text-blue-custom-2 bg-blue-custom-1 placeholder-blue-custom-2"
              :class="{ 'input-error': errors.postal_code }" v-show="!enterCode" />

            <Field name="city" v-model="user.city" rules="required">
              <v-select :options="cities" label="name" :reduce="city => city.name" dir="rtl" v-model="user.city" :placeholder="__('Select the city')" 
              class="input mt-4 text-center text-blue-custom-2 bg-blue-custom-1 placeholder-blue-custom-2" v-show="!enterCode"
              :selectable="(option) => option.province_id > 0" :clearable="false" :class="{ 'input-error': errors.city }"></v-select>
            </Field>

            <Field type="text" :placeholder="`${__('store\'s name')}`" name="shop_name" v-model="user.shop_name"
              rules="required" v-show="!enterCode" :class="{ 'input-error': errors.shop_name }"
              class="input mt-4 text-center text-blue-custom-2 bg-blue-custom-1 placeholder-blue-custom-2" />

            <Field type="text" :placeholder="`${__('Store address to send your orders')}`" name="shop_address"
              v-model="user.shop_address" v-show="!enterCode" rules="required"
              :class="{ 'input-error': errors.shop_address }"
              class="input mt-4 text-center text-blue-custom-2 bg-blue-custom-1 placeholder-blue-custom-2" />
              <Field name="introduction" v-model="user.introduction" rules="required">
              <v-select :options="introductions" dir="rtl" v-model="user.introduction" v-show="!enterCode" :placeholder="__('the method of introduction')" 
              class="input mt-4 text-center text-blue-custom-2 bg-blue-custom-1 placeholder-blue-custom-2" 
              :clearable="false" :class="{ 'input-error': errors.introduction }" :searchable="false"></v-select>
            </Field>
            <Field type="text" :placeholder="`${__('Invitation Code')}`" name="referral_code"
              v-model="user.referral_code" v-show="!enterCode"
              class="input mt-4 text-center text-blue-custom-2 bg-blue-custom-1 placeholder-blue-custom-2" />
              <label v-if="!enterCode">
                <small class="text-error">{{ __('If you were invited by someone, enter the code here') }}</small>
              </label>
            <Field v-if="enterCode" type="number" :placeholder="`${__('Verification code')}`" name="verification_code"
              v-model="verificationCode" :class="{ 'input-error': errors.verification_code }" rules="required"
              class="input mt-4 text-center text-blue-custom-2 bg-blue-custom-1 placeholder-blue-custom-2" />
             <label class="label justify-center mt-2" v-show="!enterCode" v-if="privacy">
                            <Field type="checkbox" v-model="user.privacy_confirm" name="privacy_confirm" rules="required" :class="{ 'checkbox-error': errors.privacy_confirm }" value="1"
                                class="checkbox checkbox-primary checkbox-sm" />
                            <span class="label-text font-bold mr-3 text-xs md:text-sm">
                                <label class="btn-link inline-block cursor-pointer" for="modal-privacy">{{ __('Terms and Conditions') }}</label> <span>{{ __('I accept and agree with that.') }}</span>
                            </span>
             </label>
            <button v-if="enterCode" type="button" class="btn btn-ghost !text-gray-custom-1 mt-3 mx-auto btn-sm"
              :class="{ 'pointer-events-none': timeout }" @click="resendCode">{{ timeout ? timeout : __('Request code again') }}
            </button>
          </div>
        </div>
        <div class="form-control">
          <button type="submit" class="btn btn-primary mt-4" :class="{ 'loading': loading }">{{ __(enterCode ? 'Send verification code' : 'Registration and authentication') }}</button>
        </div>
      </Form>
    </div>
  </div>
  <Teleport to="#app" v-if="privacy">
   <input type="checkbox" id="modal-privacy" class="modal-toggle" />
  <div class="modal">
    <div class="modal-box overflow-y-hidden">
      <label for="modal-privacy" class="btn btn-sm btn-circle absolute left-2 top-2">✕</label>
      <h3 class="font-bold text-lg">{{ __('Terms and Conditions') }}</h3>
       <div class="modal-content h-[640px]">
      <div v-html="privacy" class="mt-3"></div>
      </div>
      <div class="modal-action">
        <label class="btn btn-error btn-sm" for="modal-privacy">{{ __('Close') }}</label>
      </div>
    </div>
  </div>
  </Teleport>
</template>
<script setup>
import Auth from "../../../composables/shop/auth";
import DatePicker from 'vue3-persian-datetime-picker'
import { Field, Form } from "vee-validate";
import { computed, reactive, ref,onMounted } from "vue";
import { ArrowLongLeftIcon } from '@heroicons/vue/24/solid';
import router from "../../../router/shop";
const loading = Auth.loading;
const user = reactive({
  phone: '',
  national_code: '',
  birthday: '',
  referral_code: Auth.ref,
  postal_code: '',
  introduction: '',
  city: '',
  confirm: false,
  shop_name: '',
  shop_address: '',
});
const verificationCode = ref(null);
const enterCode = Auth.enterCode;
const timeout = Auth.timeout;
const cities = Auth.cities;
const privacy = Auth.privacy;
const introductions = window.nikran.introductions;
const background = computed(() => window.APP_URL + '/assets/frontend/img/bg/auth.jpg');
const isAuth = window.nikran.auth;
const backButton = () => {
  if(enterCode.value) {
    enterCode.value = false;
    Auth.stopTimer();
  }else router.push({ name: 'login' });
}
const onSubmit = () => {
  if (enterCode.value) Auth.verification(user.phone, verificationCode.value);
  else Auth.register(user);
}
const resendCode = () => Auth.register(user);
onMounted(() => Auth.getRegister());
</script>